export const useURL = () => {

    const getUrl = () => {
        const subdomain = localStorage.getItem('subdomain');
        const isLocalhost = window.location.hostname === 'localhost';
        const protocol = isLocalhost ? 'http' : 'https';
        
        return `${protocol}://${subdomain}${process.env.REACT_APP_LINK_API}/`;
    }

    return { getUrl }
}
